import { carouselData } from '@/mocks/homeData';

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点追踪
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            深度挖掘娱乐圈最受关注的热点事件
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <article
              key={item.id}
              className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-colors cursor-pointer group"
            >
              <div className="relative aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded text-xs font-medium bg-primary-500 text-white">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}